module.exports = __webpack_public_path__ + "img/oneOrange.9956a432.jpg";